import Chartkick from "chartkick";
import "chartkick/chart.js";
import jQuery from "jquery";
import DataTables from "datatables.net-bs4";
import DataTablesButtons from "datatables.net-buttons-bs4";
import DataTablesResponsive from "datatables.net-responsive-bs4";
import DataTablesButtonsHtml5 from "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.css";
const SunsetSunrise7 = [
  "#33608c",
  "#9768a5",
  "#e7718a",
  "#f6ba57",
  "#ed7846",
  "#d54c45",
  "#b81840",
];
const HueCircle19 = [
  "#1ba3c6",
  "#2cb5c0",
  "#30bcad",
  "#21B087",
  "#33a65c",
  "#57a337",
  "#a2b627",
  "#d5bb21",
  "#f8b620",
  "#f89217",
  "#f06719",
  "#e03426",
  "#f64971",
  "#fc719e",
  "#eb73b3",
  "#ce69be",
  "#a26dc2",
  "#7873c0",
  "#4f7cba",
];
const PRGn10 = [
  "#40004b",
  "#762a83",
  "#9970ab",
  "#c2a5cf",
  "#e7d4e8",
  "#d9f0d3",
  "#a6dba0",
  "#5aae61",
  "#1b7837",
  "#00441b",
];

// Initialize Chartkick
Chartkick.options = {
  colors: SunsetSunrise7,
  maintainAspectRatio: false,
  donut: true,
};

// Initialize DataTables
// DataTables();
// DataTablesButtons();
// DataTablesResponsive();
// DataTablesButtonsHtml5();
jQuery.extend(true, jQuery.fn.dataTable.defaults, {
  dom: "Bfrtip",
  searching: false,
  responsive: true,
  paging: false,
  info: false,
  buttons: [
    {
      extend: "csv",
      text: "Scarica i dati in formato CSV",
      className: "btn btn-secondary float-end btn-sm",
    },
  ],
});

// Quote di mercato
new Chartkick.PieChart("quote-mercato", "/get_stat/stats_quote_mercato/", {
  legend: "left",
});
jQuery("#table-quote-mercato").DataTable({
  ajax: {
    url: "/get_stat/stats_quote_mercato/",
    dataSrc: "",
  },
});

// Utenti registrati
new Chartkick.BarChart("utenti", "/get_stat/stats_utenti/");
jQuery("#table-utenti").DataTable({
  ajax: {
    url: "/get_stat/stats_utenti/",
    dataSrc: "",
  },
  columns: [
    {
      data: "name",
    },
    {
      data: "data.Utenti",
    },
  ],
});

new Chartkick.LineChart(
  "andamento-mensile-registrazioni",
  "/get_stat/andamento_mensile_registrazioni/",
);
jQuery("#table-andamento-mensile-registrazioni").DataTable({
  ordering: false,
  ajax: {
    url: "/get_stat/andamento_mensile_registrazioni/",
    dataSrc: "",
  },
});

new Chartkick.PieChart(
  "utenti-per-operatore",
  "/get_stat/utenti_per_operatore/",
  {
    legend: "left",
  },
);
jQuery("#table-utenti-per-operatore").DataTable({
  ajax: {
    url: "/get_stat/utenti_per_operatore/",
    dataSrc: "",
  },
});

new Chartkick.BarChart("certificati", "/get_stat/stats_certificati/");
jQuery("#table-certificati").DataTable({
  ajax: {
    url: "/get_stat/stats_certificati/",
    dataSrc: "",
  },
  columns: [
    {
      data: "name",
    },
    {
      data: "data.Certificati",
    },
  ],
});

new Chartkick.LineChart(
  "andamento-mensile-certificati",
  "/get_stat/andamento_mensile_certificati/",
);
jQuery("#table-andamento-mensile-certificati").DataTable({
  ordering: false,
  ajax: {
    url: "/get_stat/andamento_mensile_certificati/",
    dataSrc: "",
  },
});

new Chartkick.PieChart(
  "certificati-per-operatore",
  "/get_stat/certificati_per_operatore/",
  {
    legend: "left",
  },
);
jQuery("#table-certificati-per-operatore").DataTable({
  ajax: {
    url: "/get_stat/certificati_per_operatore/",
    dataSrc: "",
  },
});

new Chartkick.ColumnChart(
  "certificati-per-provincia",
  "/get_stat/certificati_per_provincia/",
);
jQuery("#table-certificati-per-provincia").DataTable({
  ajax: {
    url: "/get_stat/certificati_per_provincia/",
    dataSrc: "",
  },
});

new Chartkick.ColumnChart(
  "nemesys-per-provincia",
  "/get_stat/misure_nemesys_per_provincia/",
);
jQuery("#table-nemesys-per-provincia").DataTable({
  ajax: {
    url: "/get_stat/misure_nemesys_per_provincia/",
    dataSrc: "",
  },
});
